export default __webpack_public_path__ + "static/media/Clock.2d109ae6.svg";